import { useDebounce } from "@visiblethread/react-components";
import { useRef } from "react";

const useDebouncedScroll = ({
  callback = () => {},
  delay = 200,
  dependencies = [],
  enableXScroll = false,
  threshold = 175,
}) => {
  const scrollRef = useRef({ scrollTop: 0, scrollLeft: 0 });

  return useDebounce(
    async (e) => {
      const { target } = e;

      const { scrollHeight, scrollLeft, scrollTop, clientHeight } = target;
      const deltaY = scrollTop - scrollRef.current.scrollTop;
      const deltaX = scrollLeft - scrollRef.current.scrollLeft;
      const isXScroll = deltaX > 0 || deltaX < 0;
      const isYScroll = deltaY > 0 || deltaY < 0;
      const isValidScroll = isYScroll || (enableXScroll && isXScroll);

      if (
        isValidScroll &&
        scrollHeight - scrollTop - clientHeight < threshold
      ) {
        callback(e);
      }

      scrollRef.current = { scrollLeft, scrollTop };
    },
    delay,
    dependencies
  );
};

export default useDebouncedScroll;
